import Skeleton from 'react-loading-skeleton';
import { styled } from '@linaria/react';

const Wrapper = styled.div<{ height?: React.ComponentProps<typeof Skeleton>['height'] }>`
  height: ${({ height }) => height ?? 'auto'};
`;

interface WrappedSkeletonProps {
  wrapperProps?: React.HTMLAttributes<HTMLDivElement>;
  skeletonProps?: React.ComponentProps<typeof Skeleton>;
  height?: React.ComponentProps<typeof Skeleton>['height'];
}

const WrappedSkeleton = ({ wrapperProps, skeletonProps, height }: WrappedSkeletonProps) => {
  return (
    <Wrapper {...wrapperProps} height={height}>
      <Skeleton height={skeletonProps?.height ?? '100%'} {...skeletonProps} />
    </Wrapper>
  );
};

export default WrappedSkeleton;
